import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../i18n';

const LanguageContext = createContext();

export const LanguageProvider = ({ children, initialLanguage }) => {
  // 1. LAZY INITIALIZATION: React ilk ayağa kalktığında state'i localStorage'dan okur.
  const [language, setLanguage] = useState(() => {
    try {
      if (initialLanguage) {
        i18n.changeLanguage(initialLanguage);
        return initialLanguage;
      }

      const profileData = localStorage.getItem('tarkovProfile');
      if (profileData) {
        const parsedProfile = JSON.parse(profileData);
        if (parsedProfile.settings?.language) {
          i18n.changeLanguage(parsedProfile.settings.language);
          return parsedProfile.settings.language;
        }
      }
      // Profil yoksa i18next cache'ine bak, o da yoksa İngilizce başlat.
      const storedLanguage = localStorage.getItem('i18nextLng') || 'en';
      i18n.changeLanguage(storedLanguage);
      return storedLanguage;
    } catch (error) {
      console.error("Language init error:", error);
      i18n.changeLanguage('en');
      return 'en';
    }
  });

  const t = React.useCallback((key, options) => {
    return i18n.t(key, { ...options, lng: language });
  }, [language]);

  const lastInitialLanguageRef = React.useRef(initialLanguage);

  // 2. MERKEZİ GÜNCELLEME: Dil değiştiğinde her yeri aynı anda senkronize et.
  const changeLanguage = React.useCallback((lang) => {
    setLanguage(lang); // 1. Context State güncellenir (UI butonlarındaki highlight için)
    i18n.changeLanguage(lang); // 2. i18n çevirileri güncellenir
    localStorage.setItem('i18nextLng', lang); // 3. i18n cache garantisi

    // 4. Tarkov profilinin içindeki settings'i anında yamala (Patch)
    // Böylece Dashboard yenilendiğinde hafızasını kaybetmez.
    try {
      const profileData = localStorage.getItem('tarkovProfile');
      if (profileData) {
        const parsedProfile = JSON.parse(profileData);
        parsedProfile.settings = { ...parsedProfile.settings, language: lang };
        localStorage.setItem('tarkovProfile', JSON.stringify(parsedProfile));
      }
    } catch (error) {
      console.error("Profile language sync failed:", error);
    }
  }, []);

  useEffect(() => {
    if (initialLanguage && initialLanguage !== lastInitialLanguageRef.current) {
      lastInitialLanguageRef.current = initialLanguage;
      changeLanguage(initialLanguage);
    }
  }, [initialLanguage, changeLanguage]);

  // Güvenlik ağı: Dışarıdan bir müdahale olursa i18n'i senkron tut.
  useEffect(() => {
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
